module.exports = __webpack_public_path__ + "img/sound_max_fill.ea11b589.svg";